import { render } from "./AdsView.vue?vue&type=template&id=111b6b37"
import script from "./AdsView.vue?vue&type=script&lang=js"
export * from "./AdsView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__